import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Styled from './style';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import { Helmet } from 'react-helmet';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import { InlineShareButtons } from 'sharethis-reactjs';
import WelcomePage from './welcome';
import HardwareInstallation from './hardwareInstallation';
import ApplicationDownload from './applicationDownload';
import DownloadManuals from './downloadManuals';
import AdditionalDetails from './additionalDetails';
import VehicleInstallation from './vehicleInstallation';
import Pairing from './pairing';
import { pageUrls } from 'globalconfig/constants/keys';
import { getAuthDetails } from 'globalutils/fmUtils';
import Modal from 'globalcomponents/UI/Modal/Clutch';
import { COOKIE_AUTH_DETAILS } from 'globalconfig/constants/keys';
import { getCookie } from 'globalservices/cookie';
import { getMediaPath, mediaUrls } from 'globalconfig/constants/mediaUrls';
import SvgIcon from 'globalcomponents/SvgIcon/Base';
import { shareConfig, videoUrls } from './config';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginBottom: theme.spacing(1),
    fontSize: 30,
  },
}));

const Welcome = ({ history, login, truckInfo, handleLogout, callback, pageTitle }) => {
  const clickedModalDelete = (e) => {
    setOpenCallback(true);
  };

  const [ModalListObject2, setModalListObject2] = useState({
    header: 'Share Video',
    content: () => {},
  });
  const [openCallback, setOpenCallback] = React.useState(false);
  const [username, setUserName] = useState('');
  const [auth, setAuth] = useState(getCookie(COOKIE_AUTH_DETAILS));

  useEffect(() => {
    const token = getCookie(COOKIE_AUTH_DETAILS);
    setAuth(token);
    setUserName(token.email);
  }, [login]);

  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());

  useEffect(() => {
    if (activeStep === 0) {
      document.getElementById('backButtonStep').style.display = 'none';
    } else {
      document.getElementById('backButtonStep').style.display = 'block';
    }
  }, [activeStep]);

  const classes = useStyles();

  function getSteps() {
    if (auth && auth?.enterpriseFeatureDto?.dvirOnlyEnabled) {
      return ['Welcome', 'Application Download', 'Download Manuals', 'Additional Details'];
    }
    return [
      'Welcome',
      'Hardware Installation',
      'Vehicle Installation',
      'Device Pairing',
      'Application Download',
      'Download Manuals',
      'Additional Details',
    ];
  }

  function getStepContent(step, history) {
    const isDvirOnly = auth?.enterpriseFeatureDto?.dvirOnlyEnabled;

    const dvirSteps = [
      <WelcomePage />,
      <ApplicationDownload />,
      <DownloadManuals />,
      <AdditionalDetails truckInfo={truckInfo} history={history} />,
    ];

    const standardSteps = [
      <WelcomePage />,
      <HardwareInstallation />,
      <VehicleInstallation />,
      <Pairing />,
      <ApplicationDownload />,
      <DownloadManuals />,
      <AdditionalDetails truckInfo={truckInfo} history={history} />,
    ];

    return (isDvirOnly ? dvirSteps[step] : standardSteps[step]) || 'Unknown step';
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleNext = () => {
    let newSkipped = skipped;
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleOnLogout = () => {
    const auth = getAuthDetails(false);
    if (auth) {
      handleLogout({
        apiId: 'logout',
        callback: (type, message) => {
          if (type === 'error') {
            callback(type, message);
          } else {
            // history.push(pageUrls.login);
            window.location.href = pageUrls.login;
          }
        },
      });
    }
  };

  const baseUrl = `${process.env.CDN_URL || ''}/${window.$environment?.SERVICE_PROVIDER}`;

  const handleShareVideo = (url) => {
    setModalListObject2({
      header: 'Share Video',
      content: () => (
        <div className="connectionTypeWrapper">
          <InlineShareButtons config={{ ...shareConfig, url }} />
        </div>
      ),
    });
    clickedModalDelete();
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <link rel="manifest" href={`${baseUrl}/manifest.json`} />
        <link rel="icon" type="image/x-icon" href={`${baseUrl}/favicon.ico`} />
      </Helmet>
      <Styled.Wrapper>
        <div className={classes.root}>
          <div className="leftMenuWrapper">
            <Styled.LogoWrapper></Styled.LogoWrapper>
            <Stepper activeStep={activeStep} orientation="vertical">
              {getSteps()?.map((label) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            <div className="logout">
              <img src={getMediaPath(mediaUrls.logedIcon)} alt="logedIcon" />
              <div class="content">
                <span className="nameSection" title={username}>
                  {' '}
                  {username}
                </span>
                <span
                  className="labelLogout"
                  onClick={() => {
                    handleOnLogout();
                  }}
                >
                  Logout
                  <SvgIcon showTenantBasedColor value={mediaUrls.logout} />
                </span>
              </div>
            </div>
          </div>
          <div className="contentWrapper">
            <div className="contentWrap">
              <div className={classes.instructions}>{getStepContent(activeStep, history)}</div>
              <div
                className={`buttonSection ${
                  {
                    0: 'topbutton',
                    1: 'hardareWrapper',
                    2: 'appDownload',
                  }[activeStep] || ''
                }`}
              >
                <Button onClick={() => handleBack()} id="backButtonStep">
                  <SvgIcon value={mediaUrls.arrowRight} />
                  Previous
                </Button>

                {[1, 2, 3].includes(activeStep) && (
                  <div className="hardwareButton">
                    {activeStep === 1 && (
                      <Button variant="contained" className="referenceGuide">
                        <a
                          href="https://s1.q4cdn.com/806093406/files/doc_downloads/test.pdf"
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <SvgIcon value={mediaUrls.download} />
                          Quick Reference Guide
                        </a>
                      </Button>
                    )}
                    <Button variant="contained" className="shareVideo" onClick={() => handleShareVideo(videoUrls[activeStep])}>
                      <SvgIcon value={mediaUrls.share} />
                      Share Video
                    </Button>
                  </div>
                )}

                {activeStep !== 6 ? (
                  <Button variant="contained" onClick={() => handleNext()} id="nextButtonStep">
                    {activeStep === 0 ? 'continue onboarding' : 'Next'}
                  </Button>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
        <Modal open={openCallback} setOpen={setOpenCallback} data={ModalListObject2} connectionType />
      </Styled.Wrapper>
    </>
  );
};

export default Welcome;

Welcome.propTypes = {
  history: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
};
